module.exports = __webpack_public_path__ + "img/book11.59ebe7ed.jpg";